var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76765 6.54525C10.7438 5.77243 10.7438 4.51905 9.76765 3.74624C8.79148 2.97342 7.20829 2.97342 6.23212 3.74624C5.25596 4.51905 5.25596 5.77243 6.23212 6.54525C7.20868 7.31837 8.79148 7.31837 9.76765 6.54525ZM19.7676 11.663C18.7914 10.8902 17.2082 10.8902 16.2321 11.663C15.2559 12.4358 15.2559 13.6892 16.2321 14.462C17.2082 15.2348 18.7914 15.2348 19.7676 14.462C20.7441 13.6892 20.7441 12.4361 19.7676 11.663ZM19.6918 4.50606L18.8082 3.80654C18.3199 3.41998 17.5285 3.41998 17.0406 3.80654L6.3083 12.3032C5.82002 12.6897 5.82002 13.3162 6.3083 13.7025L7.19188 14.402C7.68016 14.7886 8.47156 14.7886 8.95945 14.402L19.6918 5.90541C20.1801 5.51916 20.1801 4.89262 19.6918 4.50606Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageIcon);
export default __webpack_public_path__ + "static/media/percentageIcon.6e6360cf04e3767a1e285a28fb9f36ec.svg";
export { ForwardRef as ReactComponent };